import React from "react";


export default function TimelineComponent() {
  return (
    <div className="about_area pt-30 timeline">
      <div className="container">
        <div className="row">
         

          {/* Text Content Section */}
          <div className="col-lg-7 col-md-6 col-sm-12 col-xs-6">
             <div className="section_title text_left">
              
              <div className="section_main_title text-left pt-5">
                <h3>Precision at Scale: <br/>Accelerating Pipeline Velocity <br/>Across Global Markets</h3>
              </div>
              
             
            </div> 

            <div className="singel_about_left">
              <div className="singel_about_left_inner">
                <div className="singel-about-content text-left">
                
                  <p>
                 The campaign redefined what speed and precision can look like in enterprise demand generation. By unifying intelligence, timing, and message relevance, it activated high-quality engagement across the buyer journey, converting attention into action at an accelerated pace.
                  <br/>The outcome was more than volume. It was momentum, built across regions, fueled by insight, and sustained beyond campaign closure.
                 </p>
                 <p><b>Regional Performance Snapshot:</b></p>
                  <div className="col-md-12 quantum-page1 text-black">
                     <p> ● <b>North America</b> accounted for 37% of total mapped accounts and 38% of identified contacts. The region showed strong alignment with future-ready cloud messaging, especially among enterprises prioritizing speed and scale.<br/></p>
                      <p>● <b>EMEA</b> contributed 33.5% of accounts and 34% of contacts, with particular strength in data transformation narratives and a consultative, multistakeholder buying approach.<br/></p>
                      <p>● <b>APJC</b> delivered a growing 29.5% share of accounts and 28% of contacts, driven by increased adoption across technology-forward industries and cloud-native mid-markets.</p>
                   

                                         </div>
                 <p>With a fully engaged Marketing Accepted Lead (MAL) pipeline now in motion, the campaign has laid the groundwork for downstream conversion, keeping the funnel primed for ongoing sales activation, not just short-term wins.</p>
                
                </div>
              </div>

              
            </div>
          </div>
           {/* Image Section */}
          <div className="col-lg-5 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb">
              <img src="/assets/images/Contacts.svg" alt="results that redefined timeline" />
              <img src="/assets/images/TAs.svg" alt="results that redefined timeline" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
